<template>
  <div class="row h-100">
    <div class="col-12 h-100">
      <div v-if="loaded" class="poppins h-100 d-flex flex-column" style="padding-bottom: 20px">
        <div class="inputs-block">
          <BlockHeader name="Details" />
          <div class="row">
            <div :class="`col-lg-${id ? '6' : '4'} col-sm-12 col-xs-12`">
              <Input v-model="name" form-group-id="name" placeholder="name" required :disabled="isImpossibleEdit" />
            </div>
            <div v-if="!id" class="col-lg-4 col-sm-12 col-xs-12">
              <Input v-model="uniqueId" form-group-id="uniqueId" placeholder="Unique id" required :disabled="isImpossibleEdit" />
            </div>
            <div :class="`col-lg-${id ? '6' : '4'} col-sm-12 col-xs-12 d-flex flex-column pt-1`">
              <b-button
                v-if="isCommonAdmin"
                variant="primary"
                size="lg"
                class="mt-4"
                :disabled="isImpossibleEdit || !name || !uniqueId || !structureList.every(({ value, type }) => value && type) || isSubmitting"
                @click="onSubmit"
              >
                {{ id ? 'Update dynamic data structure' : 'Create dynamic data structure' | i18n }}
              </b-button>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <BlockHeader name="Structure" />
            <b-button variant="primary" size="sm" class="pl-4 pr-4 ml-3" :disabled="isImpossibleEdit" @click="addNewValue">
              {{ 'Add new value' | i18n }}
            </b-button>
          </div>
          <div v-for="(data, key) in structureList" class="row" :key="key">
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Input v-model="data.value" :form-group-id="`value-${key}`" placeholder="Value" required :disabled="isImpossibleEdit" />
            </div>
            <div :class="`col-lg-${structureList.length > 1 && !isImpossibleEdit ? '5' : '6'} col-sm-11 col-xs-11`">
              <Select
                v-model="data.type"
                :options="typeOptions"
                :form-group-id="`type-${key}`"
                placeholder="Type"
                required
                :disabled="isImpossibleEdit"
              />
            </div>
            <div v-if="structureList.length > 1 && !isImpossibleEdit" class="col-lg-1 col-sm-1 col-xs-1 mt-4 pt-1">
              <b-button
                v-b-tooltip.hover
                :title="`${$translate('Remove this value')}`"
                class="edit-btn close float-none px-3"
                variant="light"
                :style="{ 'height': '46px' }"
                @click="() => removeValue(key)"
              >
                <span aria-hidden="true">&times;</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <Loader v-else />
    </div>
  </div>
</template>

<script>
import Input from '../../common/input';
import { ListMixin, NotificationMixin, DeleteRowMixin, AuthMixin } from '../../../../mixins';
import BlockHeader from '../../common/block-header';
import Loader from '../../common/loader';
import Select from '../../common/select';
import api from '../../../api';
import { DYNAMIC_DATA_TYPES } from '../../../../../../../constants';

export default {
  title: 'DynamicDataDetails',
  components: { Input, BlockHeader, Loader, Select },
  mixins: [ListMixin, NotificationMixin, DeleteRowMixin, AuthMixin],
  data() {
    return {
      loaded: false,
      name: '',
      uniqueId: '',
      id: '',
      isSubmitting: false,
      typeOptions: Object.values(DYNAMIC_DATA_TYPES).map((value) => ({ value, text: value })),
      structureList: [{ value: '', type: '' }],
      rows: [],
      isImpossibleEdit: false,
    };
  },
  async created() {
    this.id = this.$route.params.id;
    if (this.id) {
      const data = await api.dynamicData.getById(this.id);

      this.name = data.name;
      this.uniqueId = data.uniqueId;

      if (Object.keys(data.structure).length) {
        this.structureList = [];
      }
      Object.keys(data.structure).forEach((value) => {
        this.structureList.push({ value, type: data.structure[value] });
      });

      const contentList = await api.dynamicData.getContentItemsByStructureId(this.id, { page: 1, limit: 1 });
      if (contentList.totalCount) {
        this.isImpossibleEdit = true;
      }
    }
    this.loaded = true;
  },
  methods: {
    addNewValue() {
      this.structureList.unshift({ value: '', type: '' });
    },
    removeValue(index) {
      this.structureList.splice(index, 1);
    },
    async onSubmit() {
      try {
        this.isSubmitting = true;
        const structure = {};
        this.structureList.forEach(({ value, type }) => {
          structure[value] = type;
        });
        const payload = {
          name: this.name,
          structure,
        };
        if (this.id) {
          await api.dynamicData.updateDataStructure(this.id, payload);
        } else {
          payload.uniqueId = this.uniqueId;
          const result = await api.dynamicData.createDataStructure(payload);
          this.$router.push({ name: 'dynamic-data-content', params: { id: result.id } });
        }
        this.initialData = payload;
        this.showNotification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #add-team .modal-dialog {
  max-width: 700px !important;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 30px;
}
</style>
